/**
 * UI label helpers.
 * Keep human-readable label resolution centralised so any future field
 * rename (name/description/type) is a one-file change.
 */

/** Extras from `extra_charges` may use `name`, `description`, or `type`
 *  depending on when the tenant was seeded. Fall back gracefully. */
export function extraChargeLabel(x) {
  if (!x) return "";
  return x.name || x.description || x.type || x.id || "";
}
